<template>
    <v-layout style="margin: 12px;" class="row">
        <v-flex class="clsForUsers">
            <v-flex style="font-size: 26px;font-weight: 600;">Add User</v-flex>
            <v-text-field label="Enter User Name" v-model="user_name"></v-text-field>
            <v-text-field label="Enter Email" v-model="email"></v-text-field>
            <v-text-field label="Enter Password" v-model="password" type='password'></v-text-field>
            <v-flex style="text-align:right;">
                <v-btn v-if="!Update" color='primary' @click="CreateUser">Create User</v-btn>
                <v-btn v-else color='primary' @click="UpdateUserDetails">Update User</v-btn>
                <v-btn @click="ClearForm">Clear</v-btn>
            </v-flex>
        </v-flex>
        <v-flex style=" width:48%;margin: 5px;box-shadow: 0px 0px 5px 1px #00000030;min-height: 351px;max-height: 351px;overflow: scroll;">
            <v-data-table :headers="headers" :items="Admins" hide-actions disable-initial-sort height="inherit" item-key="_id" class="elevation-1">
                <template v-slot:headers="props">
                    <tr>
                    <th v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                    </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                    <td class="text-xs-center">{{ props.item.user_name }}</td>
                    <td class="text-xs-center">{{ props.item.email }}</td>
                    <td class="text-xs-center">
                        <v-icon class="clsForActions" color="primary" @click="UpdateUser(props.item)" dark>edit</v-icon>
                    </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>
<script>
export default {
    data(){
        return {
            Admins : [],
            user_id   : '',
            user_name : '',
            email     : '',
            password  : '',
            headers: [
                { text: 'User Name', value : "user_name"},
                { text: 'Email', value : "email"},
                { text: "Actions" }
            ],
            Update   : false
        }
    },
    methods:{
        UpdateUser(user){

            this.Update    = true
            this.user_id   = user._id
            this.user_name = user.user_name
            this.email     = user.email
            this.password  = ""
        },
        ClearForm(){
            this.Update    = false
            this.user_id   = ""
            this.user_name = ""
            this.email     = ""
            this.password  = ""
        },
        CreateUser(){

            let data = { "user_name" : this.user_name, "email": this.email ,"password": this.password}
            if(this.password && this.user_name && this.email){
                this.$eventHub.$emit("LOADING",'true')
                this.$http.post(`${this.$store.getters.GetProductionUrl}/login/register`,data)
                    .then(response =>{

                        let user_data = response && response['data'] && response['data']['response'] ? response['data']['response'] : null
                        user_data ? this.Admins.push(user_data) : this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Creating User","Color":"red","Close": false });
                        this.$eventHub.$emit("LOADING",'false')
                        this.ClearForm()
                    })
                    .catch(error =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Creating User","Color":"red","Close": false });
                    })
            }else{
                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Creating User Check Email / Username / Password","Color":"red","Close": false });
            }
        },
        UpdateUserDetails(){

            let data = { "user_id" : this.user_id , "update" : { } }
            data['update']['user_name'] = this.user_name
            data['update']['email'] = this.email
            this.password ? data['update']['password'] = this.password : {}

            if(this.user_id && this.user_name && this.email){
                this.$eventHub.$emit("LOADING",'true')
                this.$http.post(`${this.$store.getters.GetProductionUrl}/login/updateuser`,data)
                    .then(response =>{
    
                        let user_data = response && response['data'] && response['data']['response'] ? response['data']['response'] : null
                        let index = this.Admins.findIndex(x => x["_id"] == user_data["_id"])
                        user_data ? this.Admins.splice(index,1,user_data) : this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Creating User","Color":"red","Close": false });
                        this.$eventHub.$emit("LOADING",'false')
                        this.ClearForm()
                    })
                    .catch(error =>{
    
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Creating User","Color":"red","Close": false });
                    })
            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating User Check Email / Username","Color":"red","Close": false });
            }

        }
    },
    mounted(){

      this.$eventHub.$emit("LOADING",'true')
      this.$http.post(`${this.$store.getters.GetProductionUrl}/login/getusers`,{})
            .then(response =>{

                this.Admins = response && response['data'] && response['data']['response'] ? response['data']['response'] : []
                this.$eventHub.$emit("LOADING",'false')
            })
            .catch(error =>{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
            })
    }
}
</script>
<style scoped>
.clsForUsers{
    width:48%;
    padding: 30px;
    margin: 5px;
    box-shadow: 0px 0px 5px 1px #00000030;
}
</style>